import { BaseEntity } from '@Framework/ui/BaseEntity';
import { ReactNode } from 'react';

/**
 * https://app.abstract.com/projects/eccf5040-8372-11e8-8f11-559e5336594c/branches/master/commits/8546dd1fd72105ded7cc9a2b218beadbff6e45e4/files/EAA7C102-B7F9-4359-BA61-B818FE23FECC/layers/4F9A1147-53DC-45AF-B094-D21F496C677F
 */

/**
 * Allowed Color Types for the type Prop
 * rx and green = the same
 * primary and blue = the same
 * disabled and outline = the same
 */
export enum TEXT_TYPES {
  PRIMARY = 'primary',
  BLUE = 'blue',
  LIGHT_BLUE = 'light-blue',
  RX = 'rx',
  GREEN = 'green',
  RED = 'red',
  ORANGE = 'orange',
  LIGHT_GRAY = 'light-gray',
  GRAY = 'gray',
  DARK_GRAY = 'dark-gray',
  LIGHT_GRAY_DARK = 'light-gray-dark',
  DISABLED = 'disabled',
  OUTLINE = 'outline',
  WHITE = 'white',
  DEFAULT = 'default'
}

/**
 * TODO: this needs more declarative names
 */
export enum TEXT_VARIANTS {
  BODY1 = 'body1',
  BODY2 = 'body2',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
  CAPTION = 'caption',
  SUBTITLE1 = 'subtitle1',
  SUBTITLE2 = 'subtitle2'
}

export enum DISPLAY {
  INLINE = 'inline',
  BLOCK = 'block'
}

/**
 * TextProps Interface
 */
export interface TextProps extends BaseEntity {
  /**
   * Allowed Color Types for the type Prop
   */
  type?: TEXT_TYPES;
  /**
   * Allowed Text Variant Prop
   * h1, h2, h3, h4, h5, h6
   * body, body-bold
   * meta, meta-bold
   */
  variant?: TEXT_VARIANTS;
  /**
   * React Node
   */
  text: ReactNode;
  /**
   * Whether text is shown as bold
   */
  isBold?: boolean;
  /**
   * Whether text is shown underlined
   */
  isUnderlined?: boolean;
  /**
   * Whether text is shown emphazised
   */
  isItalic?: boolean;
  /**
   * If true, the text will have a bottom margin.
   */
  gutterBottom?: boolean;
  /**
   * how the text is displayed
   */
  display?: DISPLAY;
  /**
   * if provided will override the default component (which should be p)
   */
  component?: string;
}
